import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useVenues } from "../../redux/venue/venueHooks";
import { Tooltip, Typography } from "@mui/joy";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  formOpenSelector,
  setFormOpen,
  setSelectedVenueIDs,
} from "../../reducers/rhapsody";
import { RouterConfig } from "../config/routerConfig";
import { useNavigate } from "react-router-dom";
import { Toolbar } from "../gigsDatagrid/gigsDatagrid";

/**
 *
 * @returns {ReactElement} VenuesDatagrid page
 */
export function VenuesDatagrid() {
  const { venues } = useVenues();
  const navigate = useNavigate();
  return (
    <DataGridPremium
      slots={{
        toolbar: Toolbar,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
      }}
      rows={venues ?? []}
      onRowClick={(p) => {
        navigate(
          `${RouterConfig.venues}/${p.row.id}?sourceID=${p.row.sourceID}&sourceRecordID=${p.row.sourceRecordID}&id=${p.row.id}`
        );
      }}
      columns={[
        {
          field: "sourceID",
          headerName: "",
          width: 12,
          renderCell: (p) =>
            p.value !== 420 ? (
              <Tooltip
                arrow
                size="sm"
                sx={{ maxWidth: 150, textAlign: "center" }}
                variant="outlined"
                title="Thie item cannot be edited. It is controlled by an organization using Rhapsody."
              >
                <i className="fa-solid fa-lock"></i>
              </Tooltip>
            ) : (
              <Box />
            ),
        },
        { field: "name", headerName: "Name", width: 200 },
        { field: "description", headerName: "Description", width: 200 },
        {
          field: "address",
          headerName: "Address",
          width: 200,
          renderCell: (r) => {
            return (
              <Typography level="body2">
                {r.row.address ?? ""}
                <br />
                {r.row.city ?? ""} {r.row.state ?? ""}, {r.row.zipcode ?? ""}
              </Typography>
            );
          },
        },
      ]}
    />
  );
}
